<template>
  <ion-header style="height:68px">
    <ion-toolbar>
      <ion-button type="button" fill="clear" slot="end" class="icon-button icon close-button"
                  @click="closeModal()"></ion-button>
    </ion-toolbar>
  </ion-header>
  <ion-content ref="containerRef" :scroll-events="false" :scroll-x="false" :scroll-y="false">
    <pdf-object id="cm-pdf-viewer" :url="url" style="height:100%;"></pdf-object>

  </ion-content>
</template>

<script>

import {defineComponent} from "vue";
import {IonButton, IonContent, IonHeader, IonInput, IonPage, IonToolbar} from "@ionic/vue";


export default defineComponent({
  name: 'PdfViewerModal',
  components: {
    IonInput,
    IonPage,
    IonHeader,
    IonButton,
    IonContent,
    IonToolbar,
  },
  props: {
    url: String,
    obj: Object
  },
  setup(props, ctx) {


    function closeModal() {
      props.obj.dismiss();
    }


    return {
      closeModal
    }
  },
});
</script>

<style scoped>
ion-content {
  --background: none !important;

  canvas {
    border: 1px solid black;
  }
}

#pdf-nav-wrapper {
  display: flex;
  margin: auto;
  justify-content: center;
  align-items: center;
  gap: 20px;

  ion-button {
    height: 24px;
  }

  #page-info-wrapper {
    display: flex;
    flex-direction: row;
    justify-items: center;
    gap: 5px;
    align-items: center;

    #page_num {
      width: 50px;
    }
  }
}


.close-button {
  position: absolute;
  right: 32px;
  cursor: pointer;
}

/* All required styles for Cm BBcode elements */
</style>